const ROMAN: Record<string, number> = {
  M: 1000,
  CM: 900,
  D: 500,
  CD: 400,
  C: 100,
  XC: 90,
  L: 50,
  XL: 40,
  X: 10,
  IX: 9,
  V: 5,
  IV: 4,
  I: 1,
} as const;

export function convertToRoman(num: number) {
  let str = "";

  for (const i of Object.keys(ROMAN)) {
    const q = Math.floor(num / ROMAN[i]);
    num -= q * ROMAN[i];
    str += i.repeat(q);
  }

  return str;
}
